import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ContactInfoCardComponent } from './contact-info-card/contact-info-card.component';
export { ContactInfoCardComponent };

import { ContactInfoOnHoverDirective } from './contact-info-on-hover/contact-info-on-hover.directive';
export { ContactInfoOnHoverDirective };

import { CardDataType } from './contact-info-types';
export { CardDataType };

export const MODULE_IMPORTS = [CommonModule, ContactInfoCardComponent, ContactInfoOnHoverDirective];
export const MODULE_EXPORTS = [ContactInfoCardComponent, ContactInfoOnHoverDirective];

@NgModule({
  imports: MODULE_IMPORTS,
  exports: MODULE_EXPORTS,
})
export class GalaxyContactInfoCardModule {}
